import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

export const enteredFTR = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_ENTERED_ANSWERS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_ENTERED_ANSWERS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_ENTERED_ANSWERS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
  })(state, action);
};
